import { useEntityDetailsDataStore } from '../use-entity-details-data-store';

export const useEntityMeta = () => {
  const entityMeta = useEntityDetailsDataStore((state) => state.entityMeta);
  return entityMeta;
};
